import React from 'react';
import * as styles from './landingpage.styles';
import Hero from './hero';
import Process from './process';
import Explore from './explore';
import Inspiration from './inspiration';

const LandingPage: React.FC = () => (
  <div css={styles.container}>
    <Hero />
    <Process />
    <Explore />
    <Inspiration />
  </div>
);

export default LandingPage;
